import { Permission, Query, User } from "../misc/api/apiTypes";
import { SecurityAction, SecurityActionType } from "./SecurityActions";

export interface SecurityState {
    studyId: string;
    currentUser: User;
    isNoStudies?: boolean;
}

export const initialSecurityState: SecurityState = {
    studyId: null,
    currentUser: null,
    isNoStudies: null,
}

export function securityReducer(state: SecurityState = initialSecurityState, action: SecurityAction): SecurityState {
    switch (action.type) {
        case SecurityActionType.MultiStudiesWarning:
            return {
                ...state,
            };
        case SecurityActionType.GetStudy:
            return {
                ...state,
                studyId: action.studyId,
            };
        case SecurityActionType.NoStudiesWarning:
            return {
                ...state,
                isNoStudies: true,
            };
        case SecurityActionType.LoadCurrentUser:
            return {
                ...state,
                currentUser: action.user,
            };
        default:
            return state;
    }
}
